/*
=========================================================
Muse - Vue Ant Design Dashboard - v1.0.0
=========================================================

Product Page: https://www.creative-tim.com/product/vue-ant-design-dashboard
Copyright 2021 Creative Tim (https://www.creative-tim.com)
Coded by Creative Tim

=========================================================
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. 
*/

import Vue from "vue";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import App from "./App.vue";
import DefaultLayout from "./layouts/Default.vue";
import DashboardLayout from "./layouts/Dashboard.vue";
import DashboardRTLLayout from "./layouts/DashboardRTL.vue";
import router from "./router";
import store from "./store/store";
import axios from "axios";
import VueAxios from "vue-axios";
import GlobalMixin from "./mixin/global.mixin";
import qs from "qs";

// import './plugins/click-away'
import "./scss/app.scss";

axios.defaults.withCredentials = true;
axios.defaults.baseURL = GlobalMixin.data().baseApiUrl;
axios.defaults.paramsSerializer = function(params) {
  return qs.stringify(params, { charset: "utf-8" });
};
Vue.use(Antd);
Vue.use(VueAxios, axios);
Vue.mixin(GlobalMixin);
Vue.config.productionTip = false;

// Adding template layouts to the vue components.
Vue.component("layout-default", DefaultLayout);
Vue.component("layout-dashboard", DashboardLayout);
Vue.component("layout-dashboard-rtl", DashboardRTLLayout);
const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
// axios.get("/conf/frontapp/json").then((value) => {
//   new Vue({
//     router,
//     render: h => h(App)
//   }).$mount('#app')
// });
